import axios from "./factory";
import { Message, Loading } from "element-ui";
import { jsonFormat, urlFormat, formFormat } from "./content-type";
import store from "@/store/index";
import router from "@/router/index";
import Vue from "vue";
// import {getCookie, getQueryString} from '@/util/extends/cookieExpand'
import {
  setCookie,
  delCookie,
  getCookie,
  getQueryString,
} from "@/util/extends/cookieExpand";

//引入增强js
import "@/util/extends/toFirstUpperCase";
let getOauth2AccessTokenIndex = () => {
  const urlToken =
    getQueryString("Oauth2-AccessToken") || getQueryString("accessToken");
  if (urlToken) {
    sessionStorage.setItem("Oauth2-AccessToken", urlToken);
    setCookie("Oauth2-AccessToken", urlToken, undefined, "oppein.com", "/");
  }
  return urlToken ? urlToken : getCookie("Oauth2-AccessToken");
};
//没有api的配置链接加上static,自动分类
//这叫api树
class ApiConfig {
  constructor() {
    this.methods = ["get", "post", "put", "delete", "patch"];
    this.api = {};
    this.flag = true;
    this.lastUrl = null;
    this.api.system = {
      //通用
      authorization: {
        mock: "oss/authorization",
        server: "api/oss/authorization",
      }, //获取oss临时账户
      getOssToken: { server: "attachment/attachment/ossToken", method: "get" }, // 前端获取oss临时授权口令
      getOssGlobalId: { server: "unified-numbering/global/id", method: "get" }, //获取文件命名唯一id防止重复
      designBaseLog: { server: "designapi/design/base/log" }, //记录前端与caxa通信的日志
      batchInsertRecordsExternal: {
        server: "designapi/design/base/batchInsertRecordsExternal",
      }, //现在在行为记录表
    };

    this.api.user = {
      //用户相关
      getCurrent: { server: "designapi/design/getUserInfo", method: "get" }, //获取当前登录用户
      getCurrentById: {
        server: "designapi/design/personalCenter/getUserInfoById",
        method: "get",
      }, //获取当前登录用户
      getBillingItems: {
        server: "designapi/design/personalCenter/getUserBillingItems",
        method: "get",
      },
      getDesignDetails: {
        server: "designapi/design/personalCenter/getUserDesignDetails",
        method: "get",
      },
      getDesignSummary: {
        server: "analysis/yiGuiDataCollectApi/selectDesignerSummaryPageByCon",
        method: "post",
      },
      getUserMenuList: {
        server: "mtdsaccount/account-order/menu",
        method: "get",
      }, //获取当前登录用户菜单权限
      setUserLogout: { mock: "/logout", server: "logout", method: "get" }, //退出登录
      oauthLogin: { server: "oauth/mobile/login", requestType: "form" }, // 登陆
      getCurrentUser: {
        server: "ucenterapi/uc/internal/common/getCurrentUser",
        method: "get",
      }, // mtds登录用户信息
      authorizationUrl: {
        server: "appcenter/anonymous/wx/mp/oauth2/authorizationUrl",
      }, // 构造oauth2授权的url连接
      oauth2userInfo: {
        server: "appcenter/anonymous/wx/mp/user/oauth2/userInfo",
        method: "get",
      }, // 通过code获取授权信息
      wxUserInfo: { server: "appcenter/wx/mp/user/userInfo", method: "get" }, // 通过openid获取用户数据
      getUserBindList: {
        server: "designapi/design/wechat/getUserWeChatPageListByConToPost",
      }, // 用户绑定公众号关系列表
      bindUser: { server: "designapi/design/wechat/bindUserWeChat" }, // 绑定公众号
      unBindUser: {
        server: "designapi/design/wechat/unbindUserWeChatByUserId",
      }, // 解绑公众号
    };
    this.api.menu = {
      //用户相关权限
      listByUser: {
        server: "cases/ucenter/menu/getMenusToUser.json",
        method: "get",
      }, //获取用户所有菜单功能
      getCurrentUserMenu: {
        server: "designapi/design/insideProcessOrder/getCurrentUserMenu",
        method: "get",
      }, //用户中心权限菜单
      getBindRelationWhiteListResult: {
        server: "designapi/design/relationCase/getBindRelationWhiteListResult",
      }, //判断用户是否在免关联客户白名单内
    };
    this.api.service = {
      getDefaultPhysicalShop: {
        server:
          "designordercenter/productionOrder/receiver/getListByQry",
        method: "post",
      }, //根据 组织门店ID 查询商场默认收货地址信息
      getDefaultByServiceId: {
        server:
          "designordercenter/productionOrder/receiver/getDefaultByServiceId",
        method: "get",
      }, //根据 服务号ID 查询商场默认收货地址信息
      orderPage: {
        server: "crm/order/page",
        method: "get",
      }, //查询服务单：（crm接口）
      customerSelectPage: {
        server: "crm/customer/selectPage",
        method: "get",
      }, //根据设计师账号查询传单前服务号列表
      getSalesOrderHistoryByDesign: {
        server: "designapi/design/caxa-order/getSalesOrderHistoryByDesign",
      }, //根据设计师账号查询传单前服务号列表
      getBrandCategoryListByUserId: {
        server: "designapi/design/caxa-order/getBrandCategoryListByUserId",
        method: "get",
      }, //根据用户ID查询专业能力
      // associationServiceWithCase: { server: "designapi/design/caxa-order/saveServiceWithCase"}, //关联服务单操作接口
      getAllStandardNode: {
        server: "designapi/design/caxa-order/getAllStandardNode",
        method: "get",
      }, //查询所有标准节点
      addSalesServiceNO: {
        server: "designapi/design/caxa-order/addSalesServiceNO",
      }, //新增服务号
      getCreateLabel: {
        server: "designapi/design/caxa-order/getCreateLabel",
        method: "get",
      }, // 获取重复建档标签
      checkRepeatCreateCustomer: {
        server: "designapi/design/caxa-order/checkRepeatCreateCustomer",
      }, // 校验是否重复建档
      addSalesOrder: { server: "designapi/design/caxa-order/addSalesOrder" }, //新增服务单
      getDesignOrderRelationList: {
        server: "designapi/design/retailOrder/getDesignOrderRelationList",
      }, // 根据caseId查询该场景文件关联过的服务号列表
      saveDesignOrderRelation: {
        server: "designapi/design/retailOrder/saveDesignOrderRelation",
      }, // 复用已关联过的服务号
    };
    this.api.case = {
      judgeDesignUnionOrder: {
        server: "designapi/design/caxa-order/judgeDesignUnionOrder",
        method: "get",
      }, //上传方案时判断是否关联服务单接口
      judgeDesignUnionOrderBatch: {
        server: "designapi/design/caxa-order/judgeDesignUnionOrderBatch",
        method: "get",
      }, //判断方案是否关联服务单（批量）
      designUnionOrderlist: {
        server: "designapi/design/caxa-order/designUnionOrderlist",
        method: "get",
      }, //根据方案ID查询已经关联的服务单列表
      designOrderRelationlist: {
        server: "designapi/design/caxa-order/designOrderRelationlist",
        method: "get",
      }, //根据方案ID查询已经关联的服务单列表
      OrderRelationlistByCaseId: {
        server: "designapi/design/caxa-order/OrderRelationlistByCaseId",
        method: "get",
      }, //根据方案id和设计id查找关联服务单
      //   createProductionOrder :{ server: "designapi/design/demolitionorder/createProductionOrderForCupboard"},//一键下单接口
      createOrderOppein: {
        server: "designapi/design/demolitionorder/createOrder",
      }, //一键下单接口
      createOrder: {
        server: "designapi/design/insideProcessOrder/createOrder",
      }, //mtds一键下单接口
      saveEngineeringOrder: {
        server: "designapi/design/engineeringOrder/saveEngineeringOrder",
      }, //工程一键下单接口
      saveEngineeringOrderV2: {
        server: "designapi/design/engineeringOrder/saveEngineeringOrderV2",
      }, //工程一键下单接口
      retailCreateOrder: { server: "designapi/design/retailOrder/createOrder" }, // 零售一键下单接口
      designCreateCustomerOrder: {
        server: "designapi/design/createCustomerOrder",
      }, // 创建客户订单
      createCustomerOrder: {
        server: "designapi/design/customer/createCustomerOrder",
      }, // 零售一键下单接口
      getCaxaProductList: {
        server: "designapi/design/caxa-order/getCaxaProductList",
      }, //根据产品ID在MTDS标准品库中获取其他字段信息

      findCheckTypeList: {
        server: "designapi/design/unified/findCheckTypeList",
      }, //根据产品渠道品牌品类获取相关检查项
      matchCheckTypesNew: {
        server: "designapi/design/unifiedCheck/matchCheckTypesNew",
      }, //检查项匹配接口
      checkByRuleNew: { server: "designapi/design/retailOrder/checkByRuleNew" }, //统一检查请求受理接口
      checkByRuleByMaterial: {
        server: "designapi/design/retailOrder/checkByRuleByMaterial",
      }, //物料发起检擦
      checkByRuleByEngineeringNew: {
        server: "designapi/design/engineeringOrder/checkByRuleByEngineeringNew",
      }, //统一检查请求受理接口
      checkByRuleByEngineeringNewV2: {
        server: "designapi/design/engineeringOrder/checkByRuleByEngineeringNewV2",
      }, //统一检查请求受理接口
      matchCheckTypes: {
        server: "designapi/design/unifiedCheck/matchCheckTypes",
      }, //检查项匹配接口
      checkByRule: { server: "designapi/design/unifiedCheck/checkByRule" }, //统一检查请求受理接口
      findCheckResult: {
        server: "designapi/design/unifiedCheck/findCheckResult",
      }, //统一检查结果查询接口
      exportMaterialList: {
        server: "designapi/design/unifiedCheck/exportMaterialList",
      }, //获取物料清单文件链接
      getTaskCheckInfo: {
        server: "designapi/design/retailOrder/getTaskCheckInfo",
      }, //查询草稿任务和检查的关联
      getOrderTaskInfo: {
        server: "designapi/design/retailOrder/getSimpleOrderTaskInfo",
      }, //查询草稿任务和检查的关联
      engineerGetTaskCheckInfo: {
        server: "designapi/design/engineeringOrder/getTaskCheckInfo",
      }, //工程查询草稿任务和检查的关联
      findCheckResultByEngineering: {
        server: "designapi/design/unifiedCheck/findCheckResultByEngineering",
      }, //工程获取检查结果
      startCheckTask: { server: "designapi/design/retailOrder/startCheckTask" }, // 重新发起检查
      selectHistoryResultByConditions: {
        server: "designapi/design/unifiedCheck/selectHistoryResultByConditions",
      }, //查询我的历史检查
      selectBatchQueryResultByConditions: {
        server:
          "designapi/design/unifiedCheck/selectBatchQueryResultByConditions",
      }, //根据条件批量查询检查等级和组合柜名
      exportUnifiedCheckResult: {
        server:
          "designapi/anonymous/design/activityType/exportUnifiedCheckResult",
        method: "get",
      }, //导出检查结果
      exportModelCheckResult: {
        server:
          "designapi/anonymous/design/activityType/exportModelCheckResult",
        method: "get",
      }, //导出设计模型自检结果（按批次）
      bindAttachment: {
        server: "designapi/design/relationCase/bindAttachment",
      }, //关联场景文件接口
      saveAttachment: {
        server: "designapi/design/relationCase/saveAttachment",
      }, //关联场景文件接口

      bindThreevjiaCase: {
        server: "designapi/design/relationCase/bindThreevjiaCase",
      }, //关联场景文件3vjia外部关联
      updateUploadFilesBySplitTaskId: {
        server:
          "designapi/design/engineeringOrder/updateUploadFilesBySplitTaskId",
      }, //更新上传附件
      queryProductionOrderRelatedObjRuleList: {
        server:
          "designapi/design/retailOrder/queryProductionOrderRelatedObjRuleList",
      }, // 查询工厂订单的附件类型
      batchQueryProductionOrderRelatedObjRuleList: {
        server:
          "designapi/design/retailOrder/batchQueryProductionOrderRelatedObjRuleList",
      }, // 批量查询订单附件类型
      batchQueryProductionOrderDetailObjRuleList: {
        server:
          "designapi/design/customer/batchQueryProductionOrderDetailObjRuleList",
      }, // 按客查询可选附件列表
      getBindRelationSkipButton: {
        server: "designapi/design/relationCase/getBindRelationSkipButton",
        method: "get",
      }, //获取绑定页面跳过按钮白名单
      getExternalCheckOrderList: {
        server: "designapi/design/externalCheckOrder/getExternalCheckOrderList",
        method: "get",
      }, //根据凭证获取mtds订单数据
      findCheckResultByOrderNo: {
        server: "designapi/design/orderCheckRelation/findCheckResultByOrderNo",
      }, //根据订单编号汇总检查结果
      createOrderCheckRelation: {
        server: "designapi/design/orderCheckRelation/createOrderCheckRelation",
      }, //批量新增检查任务和订单编号的关系
      checkByRuleByEngineering: {
        server: "designapi/design/unifiedCheck/checkByRuleByEngineering",
      }, //批量新增检查任务和订单编号的关系
      getPreOrderData: {
        server: "designapi/design/order/getPreOrderData",
        method: "get",
      }, // 查询预下单数据接口
    };
    this.api.order = {
      getInfoListByCon: {
        server: "production-order/engineering/salesEngineeringOrderPlace/getInfoListByCon",
        method: "post",
      }, // 查询订单变量信息
      queryOrderVariableInfos: {
        server: "production-order/engineering/salesEngineeringOrder/queryOrderVariableInfos",
        method: "post",
      }, // 查询订单变量信息
      serviceOrderDeleteLocal: {
        server: "production-order/engineering/salesEngineeringOrderServiceOrder/deleteLocal",
        method: "post",
      }, // 删除 工程服务单
      updateLocalByHouseTypeNumberJson: {
        server: "production-order/engineering/salesEngineeringOrderServiceOrder/updateLocalByHouseTypeNumberJson",
        method: "post",
      }, // 更新 工程服务单户型
      serviceOrderCreateLocal: {
        server: "production-order/engineering/salesEngineeringOrderServiceOrder/createLocal",
        method: "post",
      }, // 新增 工程服务单
      serviceOrderUpdateLocal: {
        server: "production-order/engineering/salesEngineeringOrderServiceOrder/updateLocal",
        method: "post",
      }, // 更新 工程服务单
      getFeiShuUserByCurrentOauthUser: {
        server: "designordercenterapi/productionOrderFeishuDeliveryApi/getFeiShuUserByCurrentOauthUser",
         method: "get",
      }, //根据 当前登陆人获取飞书用户信息
      batchConvertToOssKey: {
        server: "designapi/design/attachment/batchConvertToOssKey",
        method: "post",
      }, // 网络地址批量转换
      salesDesignCheckRecord: {
        server: "designapi/salesDesignGyCheckData/record",
        method: "post",
      }, // 保存设计检查记录
      customerMainContactLabelExport: {
        server: "designordercenter/customerMainContactLabel/export",
      }, //下载excel
      exportByOrgPermissions: {
        server: "designordercenter/customerMainContactLabel/exportByOrgPermissions",
      }, //导出主合同号取号标签
      getOrgBrandCategory: {
        server: "designapi/design/insideProcessOrder/getOrgBrandCategory",
        method: "get",
      }, //获取商场品牌品类
      queryCustomerFormList: {
        server: "designapi/design/formInfo/queryCustomerFormList",
        method: "post",
      }, // 查询客户表单数据列表
      //订单价费预测信息导出(小程序)
      generateCheckResultPricePredictionExcelByCheckId: {
        server:
          "designapi/design/unifiedCheck/generateCheckResultPricePredictionExcelByCheckId",
      },
      // 根据检查id集合获取检查结果
      findCheckResultPricePredictionByCheckId: {
        server:
          "designapi/design/unifiedCheck/findCheckResultPricePredictionByCheckId",
      },
      // 根据条件查询唯一承运商物流费用详情
      findByUniqueQry: {
        server: "bsplatform/carrier/delivery/findByUniqueQry",
      },
      pageForReplaceTransmit: {
        server: "designordercenter/productionOrder/receiver/getPageListByQry",
      }, // 查询收货地址
      queryProductionOrderRelatedObjRuleList: {
        server:
          "designordercenter/linkage/queryProductionOrderRelatedObjRuleList",
      }, // 根据规则判断添加标准品按钮是否展示
      getAttributeDataList: {
        server: "bsplatform/attributeDefinition/getAttributeDataList",
      }, // 根据属性返回可选配送方式
      deliveryMethod: { server: "bsplatform/carrier/delivery/method" }, // 根据目的地编码返回可选配送方式
      productionOrderQueryQueryList: {
        server: "mtdsretailouter/productionOrderQuery/queryList",
      }, // 查询 已下单 客户订单明细列表数量
      getPlaceSizeByQry: {
        server: "designordercenter/customerOrderPlace/getPlaceSizeByQry",
      }, // 查询 已下单 客户订单明细列表数量
      getAllPlaceSizeByQry: {
        server: "designordercenter/customerOrderPlace/getAllPlaceSizeByQry",
      }, // 查询 全部 客户订单明细列表数量
      listShopOrgMarketMangeRights: {
        server:
          "designordercenter/productionOrderMarketConfig/listShopOrgMarketMangeRights",
      }, // 根据条件查询门店经营权
      // getShopManageRightByCondition: {
      //   server:
      //     "designordercenter/productionOrderMarketConfig/getShopManageRightByCondition",
      // }, // 根据条件查询招商渠道配置
      batchModifyCaxaShoppingCart: {
        server: "bffmall/mall/shoppingCart/batchModifyCaxaShoppingCart",
      }, // CAXA专用批量更新购物车接口 只处理sourceType为Caxa的购物车
      modifyShoppingCartByCondition: {
        server: "bffmall/mall/shoppingCart/modifyShoppingCartByCondition",
      }, // 批量条件更新购物车接口 有购物车ID则更新，没有则新增。
      shoppingCartGroupByConditions: {
        server: "bffmall/mall/shoppingCart/groupByConditions",
      }, // 根据条件分组查询购物车列表
      groupModifyShoppingCartByCondition: {
        server: "bffmall/mall/shoppingCart/groupModifyShoppingCartByCondition",
      }, // 批量条件分组按照不同空间产品名更新购物车接口 有购物车ID则更新，没有则新增。
      listShoppingCartAuthorityByOrgId: {
        server: "bffmall/mall/shoppingCart/listShoppingCartAuthorityByOrgId",
      }, // 根据条件查询购物车列表
      changeFileIdToServiceId: {
        server: "bffmall/mall/shoppingCart/changeFileIdToServiceId",
      }, // 根据文件ID查询购物车，并将serviceId改为传入serviceId
      productionOrderQueryList: {
        server: "mtdsretail/productionOrder/queryList",
        method: "post",
      }, // 查询订单列表
      createReceivingOrder: {
        server: "designordercenterapi/productionOrderDesignApi/createDraft", //"designordercenter/customerOrderReceiving/createDraft",
      }, // 新增客户订单
      selectProductionOrder: {
        server: "designapi/design/easyOrder/selectProductionOrder",
        method: "get",
      }, //获取工厂订单列表
      selectSalesOrder: {
        server: "designapi/design/easyOrder/selectSalesOrder",
        method: "get",
      }, //获取服务单列表
      getCustomerOrderIds: {
        server: "designapi/design/customer/getCustomerOrderIds",
        method: "get",
      }, //查询任务订单
      selectContent: {
        server: "designapi/design/dictionary/easyOrder/selectContent",
      }, //获取订单相关字典
      selectContentNew: {
        server: "designapi/design/dictionary/easyOrder/selectContentNew",
      }, //获取订单相关字典
      getProductionOrderBaseAttrList: {
        server:
          "designapi/design/3vjia-engineering-order/getProductionOrderBaseAttrList",
      }, //获取订单相关联动字典
      getProductionOrderBaseAttrLinkageRuleListByQry: {
        server:
          "designordercenter/productionOrder/rule/getProductionOrderBaseAttrLinkageRuleListByQry",
      }, //获取订单相关联动字典
      getRetailProductionOrderBaseAttrListNew: {
        server: "designordercenter/linkage/queryProductionOrderBaseAttrList",
      }, //获取订单相关联动字典
      getProductionOrderBaseAttrLinkageRuleInfoByShopId: {
        server:
          "/designordercenter/productionOrder/rule/getProductionOrderBaseAttrLinkageRuleInfoByShopId",
      }, //根据 门店ID 查询订单基本属性联动关系列表 整合 (相关权限过滤)
      getRetailProductionOrderBaseAttrList: {
        server: "designapi/design/retailOrder/getProductionOrderBaseAttrList",
      }, //获取订单相关联动字典（零售用
      getTablePattern: {
        server: "designapi/design/retailOrder/getTablePattern",
      }, // 查询台面模式
      getEngineeringBaseAttrList: {
        server: "designapi/design/engineeringOrder/getEngineeringBaseAttrList",
      }, // 获取工程的设计来源选项
      preSelect: { server: "designapi/design/easyOrder/preSelect" }, //处理组合柜信息(获取组合柜详情数据)
      selectProductionProductList: {
        server:
          "designapi/design/productionProduct/selectProductionProductList",
      }, //标准品列表
      selectEngineeringProductList: {
        server:
          "designapi/design/productionProduct/selectEngineeringProductList",
      }, //工程标准品列表
      getProductListByIds: {
        server: "designapi/design/production/getProductionByIds",
      }, //商品中心接口-根据id查询商品库标准品信息
      getProductListById: {
        server: "designapi/design/engineeringOrder/getProductListById",
      }, //根据id批量获取标准品列表
      // getRetailProductListById: {server: "designapi/design/retailOrder/getProductListById"},//根据id批量获取零售标准品列表
      getAllProductListById: {
        server: "designapi/design/productionProduct/getProductListById",
      }, //根据id批量获取全部标准品列表
      selectFaucetModel: {
        server: "designapi/design/productionProduct/selectFaucetModel",
        method: "get",
      }, //查询水龙头型号信息
      findTree: { server: "designapi/design/productionProduct/findTree" }, //查询水龙头型号信息
      getCacheRegion: {
        baseUrl: "/",
        server:
          process.env.DEPLOY_ENV === "mtds2-child"
            ? "child/microapp-caxaOneClickOrder/static/json/city.json"
            : "static/json/city.json",
        method: "get",
      },
      getCountry: {
        server:
          "designapi/design/dictionary/easyOrder/getRegionCountryListByPid",
        method: "get",
      },
      //查询地区列表信息接口
      getRegion: {
        server: "designapi/design/dictionary/easyOrder/getRegionListByPid",
        method: "get",
      },
      uploadFile: { server: "designapi/design/parse/upload" }, //上传excel
      // exportFile:{ server: "designapi/design/parse/export"}, //下载excel
      exportFile: { server: "designapi/anonymous/design/activityType/export" }, //下载excel
      designCheckResultexport: { server: "designapi/designCheckResult/export" }, //导出检查结果
      getOriginalProductionOrder: {
        server: "designapi/design/retailOrder/getOriginalProductionOrder",
      }, // 查询是否有可覆盖订单
      getDefaultCoverOrderList: {
        server: "designapi/design/customer/getDefaultCoverOrderList",
      }, // 查询默认覆盖订单
      getSalesOrderByContractNo: {
        server: "designapi/design/retailOrder/getSalesOrderByContractNo",
      }, // 根据主合同号查询服务号信息
      findDesignSoftwareIds: {
        server: "designapi/design/production/findDesignSoftwareIds",
      }, // 商品中心接口-查询资源id关联的商品
      queryTestMarket: {
        server: "designapi/design/queryTestMarket",
        method: "get",
      }, // 商品中心接口-查询测试商场
      queryCommodityInfoByMarketClassify: {
        server:
          "designapi/design/production/queryCommodityInfoByMarketClassify",
      }, // 商品中心接口-查询服务单匹配商品信息
      engineerQueryCommodityInfoByMarketClassify: {
        server:
          "designapi/design/engineeringOrder/queryCommodityInfoByMarketClassify",
      }, // 商品中心接口-查询服务单匹配商品信息
      queryCommodityInfoByMarketClassifyV2: {
        server:
          "designapi/design/production/queryCommodityInfoByMarketClassifyV2",
      }, // 商品中心接口-查询服务单匹配商品信息
      getDictHierarchyTreeListByBrandAndCategory: {
        server:
          "designapi/design/retailOrder/getDictHierarchyTreeListByBrandAndCategory",
      }, // 获取所有品牌品类列表
      queryMaterial: {
        server: "designapi/design/3vjia-engineering-order/queryMaterial",
      }, //是否非标审核
      queryOrderMappingProductRuleList: {
        server: "designapi/design/retailOrder/queryOrderMappingProductRuleList",
      }, // 查询订单映射标准品的规则
      separateOrders: { server: "designapi/design/retailOrder/separateOrders" }, //分单接口
      separateOrdersNew: {
        server: "designordercenter/customerOrder/separateOrders",
      }, //按客分单接口
      queryProductMappingOrderRuleList: {
        server: "designapi/design/retailOrder/queryProductMappingOrderRuleList",
      }, //获取下单类别
      queryProductMappingOrderRuleListNew: {
        server: "designordercenter/linkage/queryProductMappingOrderRuleList",
      }, //查询标准品可选产品类别
      requestCheckByParams: {
        server: "unifiedcheck/universalCheckApi/requestCheckByParams",
      }, //补贴算价接口
      findActivityRemainAmountListByCustomerId: {
        server:
          "designordercenter/activityOrderController/findActivityRemainAmountListByCustomerId",
      }, // 根据客户ID和客户类型查询活动剩余金额列表
      getActivityStock: { server: "bsplatform/stock/design/search" }, // 库存查询:外部业务查询库存
      getDiscountActivities: {
        server: "bffmall/mall/order/getDiscountActivities",
      }, // 查询促销活动id
      updateOrderCheckResultFlag: {
        server:
          "designapi/design/orderCheckRelation/updateOrderCheckResultFlag",
      }, //更新订单检查项标识
      getMtdsOrderList: { server: "designapi/design/getMtdsOrderList" }, //根据订单编号获取mtds订单信息
      getMtdsOrderListNew: { server: "designapi/design/getMtdsOrderListNew" }, //根据订单编号获取mtds订单信息（按客）
      getCloudSplitOrderTime: {
        server: "designapi/design/retailOrder/getCloudSplitOrderTime",
        method: "get",
      }, // 获取零售云拆单用时
      updateTableRemark: {
        server: "designapi/design/retailOrder/updateTableRemark",
      }, //更新台面备注
      getUnbindingRelationButton: {
        server: "designapi/design/relationCase/getUnbindingRelationButton",
        method: "get",
      }, // 获取解绑按钮白名单
      matchCheckTypesSingle: {
        server: "designapi/design/unifiedCheckApi/matchCheckTypesSingle",
      }, //单一检查项匹配接口
      getBelongOrderClassify: {
        server: "designapi/design/getBelongOrderClassify",
        method: "get",
      }, // 查事业线的
      getDetailsOfServiceListByOrderId: {
        server: "designapi/design/caxa-order/getDetailsOfServiceListByOrderId",
      }, // caxa查询服务单
      salesEngineeringServiceOrder: {
        server:
          "production-order/engineering/salesEngineeringServiceOrder/view",
      }, // caxa查询工程服务单
      getProductionOrder: {
        server: "designapi/design/3vjia-engineering-order/getProductionOrder",
      }, //是否非标审核
      selectMarketRankByCon: {
        server: "ma/orderActivityApi/selectMarketRankByCon",
      }, // 根据商场编码+事业线组合 查询匹配的市场等级
      createUserSetting: {
        server: "designapi/design/retailOrder/createUserSetting",
      }, // 创建个人设置
      queryUserSetting: {
        server: "designapi/design/retailOrder/queryUserSetting",
        method: "get",
      }, // 查询个人设置
      selectMyMtdsOrderPageListByCon: {
        server: "designapi/design/engineeringOrder/getPageNew",
      }, // 分页查询mtds订单
      batchTransmit: {
        server: "designapi/design/engineeringOrder/batchTransmit",
      }, // 批量传单
      batchQueryActivityTypeByCondition: {
        server:
          "designapi/design/retailOrder/batchQueryActivityTypeByCondition",
      }, // 批量查询促销类型
    };
    // 拆单相关接口
    this.api.splitOrder = {
      startSplitOrder: {
        server: "designapi/design/engineeringOrder/startSplitOrder",
      }, //发起拆单
      startSplitOrderV2: {
        server: "designapi/design/engineeringOrder/startSplitOrderV2",
      }, //发起拆单
      startAgainSplitOrder: {
        server: "designapi/design/retailOrder/startAgainSplitOrder",
      }, //全量重拆接口
      retailOrderStartSplitOrder: {
        server: "designapi/design/retailOrder/startSplitOrder",
      }, //发起拆单
      getSplitOrderResultByTaskId: {
        server: "designapi/design/engineeringOrder/getSplitOrderResultByTaskId",
      }, //刷新查单进度
      getSplitOrderTaskDetail: {
        server: "designapi/design/engineeringOrder/getSplitOrderTaskDetail",
      }, //拆单详情
      againSplitOrderByTaskDetailId: {
        server:
          "designapi/design/engineeringOrder/againSplitOrderByTaskDetailId",
      }, //重新拆单获取参数
      againSplitOrderByTaskDetailIdV2: {
        server:
          "designapi/design/engineeringOrder/againSplitOrderByTaskDetailIdV2",
      }, //重新拆单获取参数
      updateInvalidStatusByDetailIds: {
        server:
          "designapi/design/engineeringOrder/updateInvalidStatusByDetailIds",
      }, //根据明细id更新为无效状态
      updateInvalidStatusByDetailIdsV2: {
        server:
          "designapi/design/engineeringOrder/updateInvalidStatusByDetailIdsV2",
      }, //根据明细id更新为无效状态
      rollbackSplitingStatus: {
        server: "designapi/design/retailOrder/rollbackSplitingStatus",
      }, //根据明细id更新为无效状态
      deleteTask: { server: "designapi/design/engineeringOrder/deleteTask" }, //删除任务
      engineeringDeleteTask: {
        server: "designapi/design/engineeringOrder/delete",
      }, //删除任务
      receiveOrderResult: {
        server: "designapi/design/retailOrder/receiveOrderResult",
      }, // 将caxa本地拆单结果通知后端
      newGetSpecialPageByCon: {
        server: "designapi/design/special/newGetSpecialPageByCon",
      }, // 查询特殊名单（新接口）
      downloadDesignOrderTaskPageList: {
        server: "designapi/design/retailOrder/downloadDesignOrderTaskPageList",
      }, // 云拆增加批量下载导出文件夹
      addMsg: { server: "designapi/design/msg/addMsg", method: "POST" }, // 添加消息
      getMsgByUserId: {
        server: "designapi/design/msg/getMsgByUserId",
        method: "POST",
      }, // 根据用户ID查询消息列表
      updateMsgStatus: {
        server: "designapi/design/msg/updateMsgStatus",
        method: "POST",
      }, // 更新消息状态
      judgeIfShowBySpecialRoster: {
        server: "designapi/design/special/judgeIfShowBySpecialRoster",
      }, // 判断当前用户是否要展示数据
      getSplitOrderFailDetail: {
        server: "designapi/design/retailOrder/getSplitOrderFailDetail",
        method: "get",
      }, // 查询拆单失败原因
    };
    this.api.generation = {
      getCurrentUserMenu: {
        server: "designapi/design/insideProcessOrder/getCurrentUserMenu",
      }, //代传权限判断
      getShopPageList: {
        server: "designapi/design/insideProcessOrder/getShopPageList",
      }, //获取商场门店列表信息
      getMarketAllLineConfigureListByUserId: {
        server:
          "designapi/design/insideProcessOrder/getMarketAllLineConfigureListByUserId",
        method: "get",
      }, //获取商场门店列表信息

      queryCustomers: {
        server: "designapi/design/insideProcessOrder/queryCustomers",
      }, //获取客户列表信息
      queryCustomersAndMarketClassify: {
        server:
          "designapi/design/insideProcessOrder/queryCustomersAndMarketClassify",
      }, //获取客户列表信息事业线
      postByRequestDomain: {
        server: "designapi/design/insideProcessOrder/postByRequestDomain",
      }, //获取生成主合同号相关字典（品类,产品类型)
      createMainContactNo: {
        server: "designapi/design/insideProcessOrder/createMainContactNo",
      }, //获取主合同号
      createCustomer: {
        server: "designapi/design/insideProcessOrder/createCustomer",
      }, //新增客户
      updateCustomer: {
        server: "designapi/design/insideProcessOrder/updateCustomer",
      }, //编辑客户
      lifeHomeMarket: {
        server: "designapi/design/insideProcessOrder/lifeHomeMarket",
        method: "get",
      }, //判断生活家商场
      bindRelationOrder: {
        server: "designapi/design/insideProcessOrder/bindRelationOrder",
      }, //关联绑定客户
      unbindRelationOrder: {
        server: "designapi/design/insideProcessOrder/unbindRelationOrder",
      }, //解绑客户
      queryBindRelationOrderList: {
        server:
          "designapi/design/insideProcessOrder/queryBindRelationOrderList",
      }, //查询绑定关系客户列表
      getTaskModel: {
        server: "designapi/design/engineeringOrder/getTaskModel",
      }, //根据用户获取下单模式
      redirectNewPage: {
        server: "designapi/design/redirectNewPage",
        method: "get",
      }, // 获取是否跳转三合一下单页面
      getSignApplyInfo: {
        server: "designapi/design/engineeringOrder/getSignApplyInfo",
      }, //查询工程订单列表
      getSignApplyInfoV2: {
        server: "designapi/design/engineeringOrder/getSignApplyInfoV2",
      }, //查询下单申请号列表V2（按申请号聚合子单）
      queryBindRelationHistoryList: {
        server:
          "designapi/design/insideProcessOrder/queryBindRelationHistoryList",
      }, //查询工程订单列表
      getEngineeringServiceOrder: {
        server: "designapi/design/engineeringOrder/getEngineeringServiceOrder",
      }, //查询工程服务单列表
      getEngineeringServiceOrderByApplyCode: {
        server:
          "designapi/design/engineeringOrder/getEngineeringServiceOrderByApplyCode",
      }, //查询工程服务单列表
      getDesignOrderTask: {
        server: "designapi/design/engineeringOrder/getDesignOrderTask",
      }, //查询工程服务单列表
      getDesignOrderTaskPageList: {
        server: "designapi/design/retailOrder/getDesignOrderTaskPageList",
      }, //查询零售服务单列表
      getDesignOrderTaskPageListNew: {
        server: "designapi/design/retailOrder/getDesignOrderTaskPageListNew",
      }, //查询零售服务单列表
      getSignApplyInfoDetail: {
        server: "designapi/design/engineeringOrder/getSignApplyInfoDetail",
      }, //查询工程服务单详情
      getSignApplyInfoDetailV2: {
        server: "designapi/design/engineeringOrder/getSignApplyInfoDetailV2",
      }, //一键下单第一步骤，查询下单申请号详情和服务单明细V2
      getMarketUserListByUser: {
        server: "designapi/design/engineeringOrder/getMarketUserListByUser",
        method: "get",
      }, //查询工程服务单列表
      saveTask: { server: "designapi/design/engineeringOrder/saveTask" }, //保存下单进度草稿
      retailOrderSaveTask: { server: "designapi/design/retailOrder/saveTask" }, //保存下单进度草稿
      getTask: { server: "designapi/design/engineeringOrder/getTask" }, //保存下单进度草稿
      exportContractNoExcel: { server: "designapi/design/engineeringOrder/exportContractNoExcel" }, //下载合同自编号EXCEL
      previewContractNoExcel: { server: "designapi/design/engineeringOrder/previewContractNoExcel" }, //预览合同自编号EXCEL
      getTaskDetailInfo: {
        server: "designapi/design/engineeringOrder/getTaskDetailInfo",
      }, //保存下单进度草稿
      changeTaskOwner: {
        server: "designapi/design/engineeringOrder/changeTaskOwner",
      }, //保存下单进度草稿

      queryInsideRelationList: {
        server: "designapi/design/relationCase/queryInsideRelationList",
      }, //查询内部代传列表接口
      queryRetailRelationList: {
        server: "designapi/design/relationCase/queryRetailRelationList",
      }, //查询零售关联列表接口
      getSwjCaseFileUrl: {
        server: "designapi/design/relationCase/getSwjCaseFileUrl",
      }, //三维家方案文件打开接口
    };
    this.api.uc = {
      getManageLineOrgListByUserId: {
        server:
          "ucenterapi/internal/org/getManageLineOrgListByUserId",
        method: "get",
      }, //按客白名单
      getWhitelistPageList: {
        server:
          "mtdsbase/whitelist/getWhitelistPageList",
        method: "get",
      }, //按客白名单
      getFictitiousShopById: {
        server: "ucenterapi/internal/shop/getFictitiousShopById",
        method: "get",
      },
      marketRightDetail: {
        server: "ucenterapi/internal/business/marketRightDetail",
        method: "get",
      }, //经营权详情信息信息获取
      checkWhitelistByBusinessTypeAndBusinessId: {
        server:
          "mtdsbase/internal/whitelist/checkWhitelistByBusinessTypeAndBusinessId",
        method: "get",
      }, //按客白名单
      checkWhitelistByBusinessTypeAndBusinessIdGc: {
        server:
          "production-order/engineering/base/checkWhitelistByBusinessTypeAndBusinessId",
        method: "get",
      }, //工程三合一白名单
      getDitTypeListByDitTypes: {
        server: "ucenter/api/ucenter/dict/getDictListByCon.json",
        method: "get",
      }, //查询单类字典值最新
      getUcInternalDit: {
        server: "ucenterapi/uc/internal/dict/getDict",
        method: "get",
      }, //查询字典值
      getDictCacheChildrenListByType: {
        server: "mtdsbase/internal/dict/getDictCacheChildrenListByType",
        method: "get",
      }, //查询字典值
      getMAActivityTypeCacheCOList: {
        server: "mtdsbase/internal/cache/getMAActivityTypeCacheCOList",
        method: "post",
      },
      getMtdsBaseDictDataConfigCOByCode: {
        server: "mtdsbase/internal/cache/getMtdsBaseDictDataConfigCOByCode",
        method: "get",
      },
      // 获取门店列表
      getOrganizationalStructureList: {
        server: "ucenterapi/internal/org/getOrganizationalStructureList",
        method: "post",
      },
      // 根据 商场ID 获取商场信息
      selectOrgById: {
        server: "ucenterapi/internal/org/selectOrgById",
        method: "get",
      },
      // 根据 商场No 获取商场信息
      selectOrgByNo: {
        server: "ucenterapi/internal/org/selectOrgByNo",
        method: "get",
      },
    };

    this.api.ppt = {
      queryHistoryPpt: {
        server: "designapi/design/ppt/getHistoricalRecordsPageListByCon",
        method: "POST",
      }, // 查询我的历史PPT
      deleteHistoryPpt: {
        server: "designapi/design/ppt/upHistoricalRecordDelById",
        method: "POST",
      }, // 查询我的历史PPT
      addPttDownload: {
        server: "designapi/design/pptDownload/addPttDownload",
        method: "get",
      }, // 新增下载PPT记录
      queryImageDiscernTask: {
        server: "designapi/design/ppt/getPptGenerateIllustrationPageListByCon",
        method: "POST",
      }, // 查询插图识别任务列表
      cancelImageDiscernTask: {
        server: "designapi/design/ppt/upPptTaskStatus",
        method: "POST",
      }, // 取消插图识别任务
      exportImageDiscernTask: {
        server: "designapi/design/ppt/exportPpt",
        method: "GET",
      }, // 导出插图识别任务
      queryPptTemplate: {
        server: "designapi/design/ppt/queryAllModelClassifyByCondition",
        method: "POST",
      }, // 查询PPT模板列表
      queryPptSelectTemplate: {
        server: "designapi/design/ppt/queryAllModelClassifyByMarketNo",
        method: "POST",
      }, // 查询PPT模板选择列表
      queryDesignRenderImage: {
        server: "designapi/design/salesRendering/findTaskRender",
        method: "POST",
      }, // 查询设计软件渲染图
      parseModelByPpt: { server: "designapi/design/ppt/parseModelByPpt" }, //解析ppt模板
      parseModelByPptAsync: {
        server: "designapi/design/ppt/new/parseModelByPpt",
      }, // 异步解析ppt模板
      callbackModelByPpt: {
        server: "designapi/design/ppt/new/callbackModelByPpt",
        method: "GET",
      }, // 获取异步解析ppt模板结果
      saveModelByPpt: { server: "designapi/design/ppt/saveModelByPpt" }, //保存ppt模板
      deleteModelByPpt: { server: "designapi/design/ppt/deleteModelByPpt" }, //删除ppt模板
      queryByModelId: { server: "designapi/design/ppt/queryByModelId" }, //根据模板id查询ppt模板详情接口
      generatePptByModelId: {
        server: "designapi/design/ppt/generatePptByModelId",
      }, //生成ppt
      getSpaceClassify: {
        server: "designapi/design/ppt/getSpaceClassify",
        method: "get",
      }, //获取空间所属分类
      getBrandCategoryListByUserId: {
        server: "designapi/design/caxa-order/getBrandCategoryListByUserId",
        method: "get",
      }, //根据用户ID查询专业能力（品牌品类信息）
      getAllBrandCategoryList: {
        server: "designapi/design/ppt/getAllBrandCategoryList",
        method: "get",
      }, // 获取所有品牌品类列表
      getDictHierarchyTreeListByBrandAndCategory: {
        server:
          "designapi/design/ppt/getDictHierarchyTreeListByBrandAndCategory",
        method: "get",
      }, // 获取所有品牌品类列表
      getRendering: {
        server: "case/caseRenderingApi/getRendering",
        method: "POST",
      }, // 获取渲染图
    };
    // 问答管理
    this.api.questionAnswer = {
      replyContent: { server: "designapi/design/question/replyContent" }, //回复问题
      addQuestion: { server: "designapi/design/question/addQuestion" }, //新建问题
      insertTipRecord: { server: "designapi/design/question/insertTipRecord" }, //更新设计师的访问记录
      upDataProblem: { server: "designapi/design/question/upDataProblem" }, //更新问题（包含删除）
      selectList: { server: "designapi/design/question/selectList" }, //查询列表
      isFollowWechat: {
        server: "designapi/design/question/isFollowWechat",
        method: "GET",
      }, //查询是否关注设计家公众号
      getProblemDictionary: {
        server: "designapi/design/question/getProblemDictionary",
        method: "GET",
      }, //获取问题分类
      getProblemDictionaryByPid: {
        server: "faqapi/design/question/getProblemDictionaryByPid",
        method: "GET",
      }, //获取问题分类
      exportProblemList: {
        server: "designapi/design/question/exportProblemList",
        method: "GET",
      }, // 问题列表导出
      getDetails: { server: "designapi/design/question/checkDetails" }, // 问题详情
      getProductChannelList: {
        server: "designapi/design/question/getProductChannelList",
        method: "GET",
      }, // 根据品牌品类获取产品渠道
      initBase: { server: "designapi/design/question/initBase" }, // 新建问题时初始化的品牌品类产品渠道
    };

    // 我的客户
    this.api.myCustomer = {
      getAskDialog: {
        server: "designapi/design/question/getAskDialog",
        method: "GET",
      }, // 查询问答弹框地址
      getBindCaseList: {
        server: "designapi/design/caseFileRelation/getBindCaseList",
      }, // 查询客户绑定的设计方案列表
      deleteBindCaseById: {
        server: "designapi/design/caseFileRelation/deleteBindCaseById",
        method: "DELETE",
      }, // 删除设计方案绑定关系
      getHouseData: { server: "designapi/design/customer/getHouseData" }, // 户型管理接口
      deleteHouseDataByHouseId: {
        server: "designapi/design/customer/deleteHouseDataByHouseId",
        method: "GET",
      }, // 删除量尺户型数据
      addHouseDataRecord: {
        server: "designapi/design/customer/addHouseDataRecord",
      }, // 增加方案fileid与知户型数据的关联关系
      findSalesOrderCustomerCaseListByCon: {
        server:
          "designapi/design/caxa-order/findSalesOrderCustomerCaseListByCon",
      }, // 根据传参分页查询客户方案列表(客户方案列表页)
      findSalesOrderCustomerCaseDetailListByCon: {
        server:
          "designapi/design/caxa-order/findSalesOrderCustomerCaseDetailListByCon",
      }, // 根据传参查询客户方案详情列表(我的客户点击方案按钮)
      findSalesRenderingPicListBySchemeId: {
        server:
          "designapi/design/caxa-order/findSalesRenderingPicListBySchemeId",
      }, // 根据方案ID查询渲染图列表(方案详情页)
      findBindCaseAttachmentListByCon: {
        server: "designapi/design/caxa-order/findBindCaseAttachmentListByCon",
      }, // 根据方案ID查询渲染图列表(方案详情页)
      saveExamination: {
        server: "designapi/design/examination/saveExamination",
      }, // 保存客户方案审查记录
      queryExaminationByBusinessId: {
        server: "designapi/design/examination/queryExaminationByBusinessId",
        method: "GET",
      }, // 根据业务id查询客户方案审查记录
      queryOrderByServiceId: {
        server: "designapi/design/examination/queryOrderByServiceId",
        method: "GET",
      }, // 根据服务号id查询下单记录
      interactionRecord: { server: "case/interactionRecord/upload" }, // 互动记录上传接口
      getMultiBusinessObjectCount: {
        server:
          "case/anonymous/design/interaction/count/getMultiBusinessObjectCount",
      }, // 业务对象多操作类型计数结果查询接口
    };
    this.api.checkForm = {
      queryQuotationResultByQuotationIdAndTraceId: {
        server: "quotation/designQuotationResultController/queryQuotationResultByQuotationIdAndTraceId",
        method: "POST",
      }, // 根据报价ID和追溯id查询报价结果和报价项结果
      processModelCheck: {
        server: "designapi/design/unifiedCheck/processModelCheck",
        method: "POST",
      }, // 按 taskId（或 batchId）拉取远程统一检查结果
      doQuotationParallel: {
        server: "designapi/design/quote/doQuotationParallel",
        method: "POST",
      }, // 发起报价（并行）- 模块自检
      getSpecifiedAccountMarketToken: {
        server: "quotation/designQuotationMarketConfigController/getSpecifiedAccountMarketToken",
        method: "POST",
      }, // 获取指定商场token
      queryOrderStorageTimeByQry: {
        server: "designapi/design/orderStorageTime/queryOrderStorageTimeByQry",
      }, // 获取订单周期
      submitDesignFormInfo: {
        server: "designapi/design/formInfo/submitDesignFormInfo",
      }, // 提交表单内容
      saveDesignFormInfo: {
        server: "designapi/design/formInfo/saveDesignFormInfo",
      }, // 保存表单内容
      queryFormContentById: {
        server: "designapi/design/formInfo/queryFormContentById",
        method: "GET",
      }, // 查询表单内容详情
      queryFormContentByFormInfoId: {
        server: "designapi/design/formInfo/queryFormContentByFormInfoId",
        method: "GET",
      }, // 查询表单内容详情
      queryFormContentListByFormInfo: {
        server: "designapi/design/formInfo/queryFormContentListByFormInfo",
      }, // 根据表单信息查询内容
      queryFormInfoPage: {
        server: "designapi/design/formInfo/queryFormInfoPage",
        method: "POST",
      },
      exportFormInfoList: {
        server: "designapi/design/formInfo/exportFormInfoList",
        method: "POST",
        responseType: "blob",
      },
      queryHistoryFormContentListByFormInfo: {
        server:
          "designapi/design/formInfo/queryHistoryFormContentListByFormInfo",
      }, // 根据表单信息查询历史列表内容
      queryFormInfoSummaryResultByCon: {
        server: "designapi/design/formInfo/queryFormInfoSummaryResultByCon",
      }, //根据条件查询表单汇总结果
      queryHistoryCheckResultByProductionOrderId: {
        server:
          "designapi/design/formInfo/queryHistoryCheckResultByProductionOrderId",
      }, // 根据工厂订单ID查询历史检查记录
      queryOrderCheckResult: { server: "designapi/design/excel/result/query" },
      exportOrderCheckResult: {
        server: "designapi/design/excel/download",
        method: "POST",
      },
      systemData: { server: "bsplatform/product/systemData", method: "GET" },
      getAllBase: {
        server: "designapi/defaultBase/getAllBase",
        method: "POST",
      },
      baseOptionsByCode: {
        server: "bsplatform/stock/base/listOptionsByCode",
        method: "GET",
      }, //根据字典编码获取选项  "base 对应基地    chargeType  对应管控类型     materialsType  对应物料类型"
      materialCheck: {
        server: "designapi/design/stockVerifyOrder/materialCheck",
      }, // 设计过程发起物料检查
      calculateStockVerifyOrderResults: {
        server:
          "designapi/design/stockVerifyOrder/calculateStockVerifyOrderResults",
      }, // 设计过程计算库存校验结果接口
      exportStockVerifyOrderResults: {
        server:
          "designapi/design/stockVerifyOrder/exportStockVerifyOrderResults",
      }, // 设计过程计算库存校验结果接口
      findStockVerifyOrderResults: {
        server: "designapi/design/stockVerifyOrder/findStockVerifyOrderResults",
        method: "POST",
      }, // 传单前检查查询库存校验结果
      confirmAndSaveStockVerifyOrderResults: {
        server:
          "designapi/design/stockVerifyOrder/confirmAndSaveStockVerifyOrderResults",
        method: "POST",
      }, // 传单前检查确认及保存库存校验结果
      listByCode: {
        server: "bsplatform/productDict/listByCode",
        method: "GET",
      }, //根据字典编码获取下拉选项
      getTechnicalReviewUrl: {
        server: "mtdsretailouter/productionOrder/getTechnicalReviewUrl",
      }, // 是否发起检查
      getNonStandardMaterialList: {
        server:
          "production-order/engineering/salesEngineeringOrder/getNonStandardMaterialList",
        method: "GET",
      }, //制造特殊工艺审批流程查询接口
      getNonStdMaterialWoodDoor: {
        server:
          "designordercenterapi/productionOrderMscsApi/getNonStdMaterialWoodDoor",
        method: "POST",
      }, //MSCS - 查询木门非标材料
      getOrderByNo: {
        server: "production-order-api/engineering/getOrderByNo",
        method: "GET",
      }, //
      queryDesignFormInfoList: {
        server: "designapi/design/formInfo/queryDesignFormInfoList",
      }, //查询表单列表
    };

    // 库存中心(库存单据)
    this.api.inventory = {
      // 库存单据列表查询
      pageCriteriaQuery: {
        server: "bsplatform/stock/bill/pageCriteriaQuery",
        method: "POST",
      },
    };
  }

  /**
   * 格式化api链接
   * @Author BillionChen
   * @param  {Boolean}   isStatic [是否静态api(没有ajax方法的配置链接)]
   * @return {[type]}             [description]
   */
  toUrl(isStatic = undefined) {
    let rs = {};
    let arr = [];
    for (let v in this.api) {
      rs[v] = {};
      //
      for (let item in this.api[v]) {
        if (this.api[v][item].static !== isStatic) continue; //静态链接不纳入api
        if (this.api[v][item]["server"]) {
          rs[v][item] = process.env.BASE_PATH + this.api[v][item]["server"];
          arr[item] = this.api[v][item];
        }
      }
    }
    return arr;
  }
  getUrl(data = {}) {
    if (data && data.server && typeof data.server === "string") {
      if (data.baseUrl && typeof data.baseUrl === "string") {
        return `${data.baseUrl}${data.server}`;
      } else {
        return `${process.env.BASE_PATH}${data.server}`;
      }
    }
  }
  setAxios(config, params, query, customHeaders) {
    let configs = { method: "post", headers: customHeaders };
    let data = params;
    if (config.requestType === "form") {
      //默认content-type是json格式 如果要要用form-data提交里面需要加参数requestType
      let formatData = urlFormat(params);
      configs.headers = { ...configs.headers, ...formatData.headers };
      data = formatData.data;
    }
    if (
      typeof config.method === "string" &&
      this.methods.includes(config.method.toLowerCase())
    ) {
      configs.method = config.method.toLowerCase();
      if (configs.method === "get" || configs.method === "delete") {
        configs.params = data;
      }
    }
    if (!configs.params) {
      configs.data = data;
      if (query) {
        configs.params = query;
      }
    }
    if (
      params &&
      Array.isArray(params) &&
      params.length > 0 &&
      params[0].sessionTrackId &&
      params[0].operateId
    ) {
      configs.headers["sessionTrackId"] = params[0].sessionTrackId;
      configs.headers["operateId"] = params[0].operateId;
    }
    if (
      config.server === "designapi/design/engineeringOrder/startSplitOrder" ||
      config.server === "designapi/design/retailOrder/startSplitOrder" ||
      config.server ===
        "designapi/design/engineeringOrder/againSplitOrderByTaskDetailId" ||
      config.server ===
        "designapi/design/engineeringOrder/againSplitOrderByTaskDetailIdV2" ||
      config.server === "designapi/design/engineeringOrder/startSplitOrderV2"
    ) {
      configs.headers["sessionTrackId"] = params.sessionTrackId;
      configs.headers["operateId"] = params.operateId;
    }
    configs.url = this.getUrl(config);
    // 如果有自定义 header，直接设置到 configs 中（含 common 以确保被 dispatchRequest 采用）
    if (customHeaders && Object.keys(customHeaders).length > 0) {
      Object.keys(customHeaders).forEach((key) => {
        configs.headers[key] = customHeaders[key];
      });
    }
    return axios(configs)
      .then(this.checkStatus)
      .then(this.checkJson)
      .then(this.checkError(config));
  }
  request() {
    let rs = {};
    for (let module in this.api) {
      rs[module] = {};
      for (let item in this.api[module]) {
        let itemInfo = this.api[module][item];
        rs[module][item] = (params = {}, query = {}, customHeaders = {}) => {
          return this.setAxios(itemInfo, params, query, customHeaders);
        };
      }
    }
    return rs;
  }
  sentForm(option = {}, data) {
    data.AppCode = "CAXA";
    data.SubAppCode = "CAXAPC001";
    data["Oauth2-AccessToken"] = getOauth2AccessTokenIndex();
    let url = this.getUrl(option);
    if (!url || (!this.flag && url === this.lastUrl)) {
      return;
    }
    this.flag = false;
    this.lastUrl = url;
    let forms = document.createElement("form");
    forms.setAttribute("style", "diaplay:none");
    forms.setAttribute("target", "");
    forms.setAttribute("method", option.method || "post");
    forms.setAttribute("action", url);
    let tBody = document.getElementsByTagName("body")[0];
    tBody.appendChild(forms);
    let creatEleInput = (key, value) => {
      let inputs = document.createElement("input");
      inputs.setAttribute("style", "opacity:0");
      inputs.setAttribute("name", key);
      inputs.setAttribute("value", value);
      forms.appendChild(inputs);
    };
    for (let k in data) {
      if (data[k]) {
        creatEleInput(k, data[k]);
      }
    }
    forms.submit();
    setTimeout(() => {
      forms.parentNode.removeChild(forms);
      this.flag = true;
    }, 1000);
  }
  export() {
    let rs = {};
    for (let module in this.api) {
      rs[module] = {};
      for (let item in this.api[module]) {
        let itemInfo = this.api[module][item];
        rs[module][item] = (params = {}) => {
          return this.sentForm(itemInfo, params);
        };
      }
    }
    return rs;
  }
  checkStatus(response) {
    // debugger
    // 如果 http 状态码正常, 则直接返回数据
    // 异常状态下, 把错误信息返回去
    // 因为前面我们把错误扶正了, 不然像 404, 500 这样的错误是走不到这里的
    // 未登录被302拦截后,没有返回//这里应该有坑的...但暂时是不会出问题的
    if (!response) {
      return {
        status: false,
        code: "500",
        exception: "系统错误，请稍后重试!",
        login: false,
      };
    }
    return [200, 304].indexOf(response.status) !== -1
      ? response.data
      : {
          status: false,
          code: response.status,
          exception: [
            response.status,
            response.statusText,
            response.request.responseURL,
          ].join(" "),
          message: response.message,
        };
  }

  checkJson(data) {
    return (typeof data).toLowerCase() === "string" ? JSON.parse(data) : data;
  }

  checkError(config) {
    return (data) => {
      if (data && data.status) {
        return data;
      } else {
        !data &&
          (data = {
            status: false,
            code: "500",
            msg: "服务器异常，请稍后再试！(未知异常)",
          });
        if (
          ["110001", "110013", "110016"].join(",").indexOf(data.code) !== -1
        ) {
          // sessionStorage.setItem("Oauth2-AccessToken",'0000')
          // window.location = data.data + encodeURIComponent(location.href)
          router.push({
            path: "/resources/loseToken",
          });
          return data;
        }

        if (!(data.code === "200" || data.code === "100000")) {
          let msg =
            data.message ||
            data.msg ||
            data.exception ||
            data.errMsg ||
            "系统错误，请稍后重试!";
          let elLoadingMask = document.querySelector(
            ".el-loading-mask.is-fullscreen",
          );
          if (elLoadingMask) {
            elLoadingMask.style.display = "none";
          }
          data.msg = msg;
          // new Vue().$message.error({
          //     message: msg
          // });
          return data;
        }
      }
      if (data && !data.status) {
        return data;
      }
    };
  }
}

const apiUrls = new ApiConfig().toUrl();
// let apiNames = [];
// for (let module in apiUrls) {
//     for (let item in apiUrls[module]) {
//         let name = 'api' + module.toFirstUpperCase() + item.toFirstUpperCase();
//         apiNames.push(name);
//     }
// }
export const linkPost = (api, option, downloadName) => {
  // 导出 post
  const readBlobByReader = (blob, fileName) => {
    const fileReader = new FileReader();
    fileReader.onload = (res) => {
      const { result } = res.target; // 得到字符串
      if (result.indexOf("status") !== -1 && result.indexOf("code") !== -1) {
        let jsonData = JSON.parse(result);
        if (jsonData.message) {
          Message.error(jsonData.message);
        }
      } else {
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      }
    };
    fileReader.onerror = (res) => {
      Message.error("解析文件异常");
    };
    fileReader.readAsText(blob, "utf-8");
  };
  if (apiUrls[api] && process.env.BASE_PATH) {
    // let url = CURRENT_ENV_PATH.baseUrl + apiConfig[api].url
    let data = {};
    if (typeof option === "object" && option && !Array.isArray(option)) {
      data = { ...option };
    }
    const loading = Loading.service({
      lock: true,
      text:
        localStorage.getItem("orderLocaleLanguage") === "cn"
          ? "正在导出,请稍等..."
          : "Exporting, please wait...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    const params = {
      method: apiUrls[api].method || "post",
      baseURL: process.env.BASE_PATH,
      url: apiUrls[api].server,
      responseType: "blob",
    };
    if (params.method.toUpperCase === "GET") {
      params.params = data;
    } else {
      params.data = data;
    }
    console.log("params", params);
    axios(params)
      .then((res) => {
        // this.excellLoading = false
        loading.close();
        if (!res || !res.data) {
          Message.error("导出失败");
          return;
        }
        if (res.data) {
          // 导出出错，返回json错误信息
          readBlobByReader(res.data, downloadName);
        }
      })
      .catch((error) => {
        // this.excellLoading = false
        loading.close();
        Message.error(error.message || "导出失败");
        console.log("导出失败error", error);
      });
  }
};
export default apiUrls;
// export const apiNameList = apiNames;
export const staticApi = new ApiConfig().toUrl(false, true);
export const mock = new ApiConfig().toUrl(true);
export const api = new ApiConfig().request();
export const exportData = new ApiConfig().export();



// WEBPACK FOOTER //
// ./src/api/index.js